import { generateClient } from 'aws-amplify/api';
import { createTimeEntry } from "../graphql/mutations";

const client = generateClient();

const newTimeEntry = async ({ id, date, scopeId, hours, isApproved = false, customerId, crewMemberId, locationId, status = 'PENDING' }) => {
    try {
        const {
            data: { createTimeEntry: timeEntry },
        } = await client.graphql({
            query: createTimeEntry,
            variables: {
                input: {
                    id,
                    date,
                    scopeId,
                    hours,
                    isApproved,
                    customerId,
                    crewMemberId,
                    locationId,
                    status,
                },
            },
        });
        return timeEntry;
    } catch (ex) {
        console.error("Failed to create time entry", ex);
    }
};

export default newTimeEntry;